module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921055651_T.7bdd8587.jpg";